import React from "react";
import ApplyModuleCard from "./../ApplyingModulation/ApplyModuleCard";
import picJaqu from "./../../images/picJaqu.png";
// TEMPORARILY DISABLED - bandwidth savings (~52 MB)
// import videoJaq from "./../../videos/3D_Morphing_FINAL_S_1.mp4";

const ApplyingMorphing = () => {
  const para =
    "« The morphing engine of Morphos is unlike anything for live modulation and timbre exploration »";
  const name = " Jaquarius";
  const country = "France";

  return (
    <>
      <ApplyModuleCard
        para={para}
        name={name}
        picJaqu={picJaqu}
        country={country}
        video={null}
      />
      {/* <div className="mainApplyModule">
        <div className="mainContainerApplyingMod">
          <div className="txtPartApplyMod">
            <p className="paraApplyModTxt">
              <AiOutlineDoubleLeft className="iconsApplyMod" />
              Applying a different modulation on each paramete is really great
              for
              <br /> me!
              <AiOutlineDoubleRight />{" "}
            </p>
            <div className="picPartUserAppMod">
              <img src={picJaqu} alt="" className="imgJaqu" />
              <p className="nameApplyModHolder">
                {" "}
                Jaquarius
                <br />
                <span className="spCountryAppMod">France</span>
              </p>
            </div>
          </div>
          <div className="mainVideoApplyMod">
            <Player src="https://media.w3.org/2010/05/sintel/trailer_hd.mp4">
              <BigPlayButton position="center" />
            </Player>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default ApplyingMorphing;
